import { render, staticRenderFns } from "./UploadFileTab.vue?vue&type=template&id=20cfd3b7"
import script from "./UploadFileTab.ts?vue&type=script&lang=ts&external"
export * from "./UploadFileTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports